var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8962_3951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7247 8.52267V11.907H13.494V10.3687H11.0327M9.18671 10.3687V13.1377M9.18671 10.3687V9.13801H11.0327V10.3687M9.18671 10.3687H11.0327M9.18671 15.2913V13.1377M9.18671 13.1377H11.3404M1.18738 1.13867H6.72538V6.67667H1.18738V1.13867ZM9.18671 1.13867H14.7247V6.67667H9.18671V1.13867ZM6.72538 9.13801H1.18738V14.676H6.72538V9.13801Z",
    stroke: "#545454",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5521,
    y: 3.51367,
    width: 0.799934,
    height: 0.799934,
    stroke: "#545454",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.58167,
    y: 3.51367,
    width: 0.799934,
    height: 0.799934,
    stroke: "#545454",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.58167,
    y: 11.5205,
    width: 0.799934,
    height: 0.799934,
    stroke: "#545454",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6116,
    y: 14.1646,
    width: 0.799934,
    height: 0.799934,
    stroke: "#545454",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.2444,
    y: 14.1646,
    width: 0.799934,
    height: 0.799934,
    stroke: "#545454",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8962_3951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrScan);
export default __webpack_public_path__ + "static/media/QrScan.036d0519a94e2ddce723dc7a53d5c868.svg";
export { ForwardRef as ReactComponent };